import { Injectable } from '@angular/core';

import { RoutingService, GlobalMessageService, User, B2BUserRole, GlobalMessageType } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, pluck, map, tap } from 'rxjs/operators';
import {UserAccountFacade} from '@spartacus/user/account/root';

@Injectable({
    providedIn: 'root',
})
export class UigCustomUserPaymentsGuard  {

    SHOW_INVOICES_OVERVIEW = 'show_invoices_overview';
    roles: string[];

    constructor(
        protected userAccountFacade: UserAccountFacade,
        protected routingService: RoutingService,
        protected globalMessageService: GlobalMessageService
    ) { }

    canActivate(): Observable<boolean> {
        return this.userAccountFacade.get().pipe(
            filter((user: User) => user && Object.keys(user).length > 0),
            tap((user) => {
                this.roles = user.roles;
            }),
            pluck('authorities'),
            map(() => {
                const hasRole = (this.roles && this.roles.includes(this.SHOW_INVOICES_OVERVIEW));

                if (!hasRole) {
                    this.routingService.go({ cxRoute: 'home' });

                    this.globalMessageService.add(
                        { key: 'organization.notification.noSufficientPermissions' },
                        GlobalMessageType.MSG_TYPE_WARNING
                    );
                }

                return hasRole;
            })
        );
    }
}
